export const create = {
  form: {
    name: 'Name',
    code: 'Code',
    submit: 'Submit',
    requireName: 'Please input employee name!',
    requireCode: 'Please input employee code!',
  },
  pageHeader: {
    title: 'New employee',
  },
}
